import { UserRepository } from 'application/repositories/UserRepository';
import {
    BeforeEkycPayload,
    BeforeEkycResponse,
    MFASettingPayload,
    MemberCorpoPayload,
    MemberInfoResult,
    RegistStepOnePayload,
    UserInfo,
    UserInfoResult,
} from 'domain/entities/UserEntity';
import axiosConfig from 'infrastructure/config/axios';

export class UserAPI implements UserRepository {
    async registUserInfo(userInfo: UserInfo) {
        const API_URL = '/mypage/register';
        const response = await axiosConfig.getAxiosConfig().post(API_URL, userInfo);
        return response.data;
    }

    async getInfoToRegist() {
        const API_URL = '/mypage/register';
        const response = await axiosConfig.getAxiosConfig().get(API_URL);
        return response.data;
    }

    async getMemberCorproInfo() {
        const API_URL = '/mypage/info-member-corpo';
        const response = await axiosConfig.getAxiosConfig().get(API_URL);
        return response.data;
    }

    async registMemberCorproInfo(payload: MemberCorpoPayload) {
        const API_URL = '/mypage/register-corpo';
        const response = await axiosConfig.getAxiosConfig().post(API_URL, payload);
        return response.data;
    }

    async editMemberCorproInfo(payload: MemberCorpoPayload): Promise<any> {
        const API_URL = '/mypage/edit-corpo';
        const response = await axiosConfig.getAxiosConfig().put(API_URL, payload);
        return response.data;
    }

    async updateLoanConsul(): Promise<any> {
        const API_URL = '/mypage/update_loan_consul';
        const response = await axiosConfig.getAxiosConfig().put(API_URL);
        return response.data;
    }

    async getUserInfo(): Promise<MemberInfoResult> {
        const API_URL = `/mypage`;
        const response = await axiosConfig.getAxiosConfig().get(API_URL);
        return response.data;
    }

    async getUserBasicInfo(): Promise<UserInfoResult> {
        const API_URL = `/mypage/basic-info`;
        const response = await axiosConfig.getAxiosConfig().get(API_URL);
        return response.data;
    }

    async deleteAccount(): Promise<any> {
        const API_URL = `/mypage/delete-member`;
        const response = await axiosConfig.getAxiosConfig().delete(API_URL);
        return response.data;
    }

    async settingMFA(payload: MFASettingPayload): Promise<any> {
        const API_URL = `/mypage/setting-mfa`;
        const response = await axiosConfig.getAxiosConfig().put(API_URL, payload);
        return response.data;
    }

    async registBeforeEkyc(payload: BeforeEkycPayload): Promise<any> {
        const API_URL = `/mypage/register-before-ekyc`;
        const response = await axiosConfig.getAxiosConfig().put(API_URL, payload);
        return response.data;
    }

    async getDefaultInfo() {
        const API_URL = `/mypage/info-default-important/`;
        const response = await axiosConfig.getAxiosConfig().get(API_URL);
        return response.data;
    }

    async regsitUserStep1(payload: RegistStepOnePayload): Promise<any> {
        const API_URL = `/mypage/register-step-1`;
        const response = await axiosConfig.getAxiosConfig().post(API_URL, payload);
        return response.data;
    }

    async regsitUserStep2(payload: any): Promise<any> {
        const API_URL = `/mypage/register-step-2`;
        const response = await axiosConfig.getAxiosConfig().post(API_URL, payload);
        return response.data;
    }

    async updateUserBasicInfo(payload: any): Promise<any> {
        const API_URL = `/mypage/save-basic-info`;
        const response = await axiosConfig.getAxiosConfig().post(API_URL, payload);
        return response.data;
    }

    async startEkyc(payload: { memberAccountId: number }): Promise<any> {
        const API_URL = `/ekyc-start`;
        const response = await axiosConfig.getAxiosConfig().post(API_URL, payload);
        return response.data;
    }
    async getBeforeEkycInfo(): Promise<BeforeEkycResponse> {
        const API_URL = `/mypage/before-ekyc`;
        const response = await axiosConfig.getAxiosConfig().get(API_URL);
        return response.data;
    }
}
